// src/components/SearchCips/CategoryToggle.jsx
import React from "react";

const CategoryToggle = React.memo(({ mainCategory, setMainCategory }) => {
  return (
    <div className="relative mt-4 w-full h-10 bg-zinc-100 rounded-lg">
      {/* Buttons */}
      <div className="absolute inset-0 flex z-20">
        <button
          className={`relative z-20 flex-1 flex items-center justify-center border rounded-lg ${
            mainCategory === "Cluster"
              ? "text-zinc-600 border-l border-zinc-300 rounded-r-none border-r-0"
              : "text-indigo-500 font-semibold border border-indigo-500"
          } hover:text-indigo-500`}
          onClick={() => setMainCategory("Program")}
        >
          Program
        </button>
        <button
          className={`relative z-20 flex-1 flex items-center justify-center border rounded-lg ${
            mainCategory === "Program"
              ? "text-zinc-500 border-zinc-300 rounded-l-none border-l-0"
              : "text-indigo-500 font-semibold border-indigo-500"
          } hover:text-indigo-500`}
          onClick={() => setMainCategory("Cluster")}
        >
          Cluster
        </button>
      </div>

      {/* Toggle Slider */}
      <div className="absolute inset-0 overflow-hidden rounded-lg z-10">
        <span
          aria-hidden="true"
          className={`${
            mainCategory === "Cluster" ? "translate-x-full" : "translate-x-0"
          } inline-block w-1/2 h-full transform bg-white transition-transform duration-200 ease-in-out rounded-lg`}
        />
      </div>
    </div>
  );
});

export default CategoryToggle;
